/* Safir motion layer, v2. Scroll-triggered reveals driven by one
   IntersectionObserver, with a per-group sibling stagger and a distinct
   effect per element kind (hero rise-and-focus, card lift-in, directional
   slides, heading + accent-bar sequence). Reveals run as one-shot CSS
   animations with backwards fill, not transitions, so after landing an
   element returns to its normal styles and the polish layer's hover
   transitions work untouched. Progressive enhancement: content is only
   hidden after this script tags it and gates it behind the
   html.safir-motion class, and a safety timer reveals everything
   regardless, so every failure mode degrades to a fully visible page.
   Respects prefers-reduced-motion. No dependencies. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* fx names map to keyframes in snippets/safir-motion.liquid. Hero text
     and CTA share one group so the sibling stagger sequences
     headline -> subhead -> button. */
  const GROUPS = [
    { sel: '.hero-wrapper .text-block, .hero-wrapper .button', fx: 'hero' },
    { sel: '.safir-hiw__step', fx: 'card' },
    { sel: '.safir-buy__card', fx: 'card' },
    { sel: '.safir-ing__col', fx: 'card' },
    { sel: '.safir-creator__card', fx: 'card' },
    { sel: '.safir-ugc__item', fx: 'card' },
    { sel: '.safir-creators__tier', fx: 'card' },
    { sel: '.safir-compare__row', fx: 'left' },
    { sel: '.safir-founder__media', fx: 'left' },
    { sel: '.safir-founder__content', fx: 'right' },
    { sel: '.safir-story__item', fx: 'up' },
    { sel: '.safir-villain__file', fx: 'card' },
    { sel: '.safir-villain__kicker, .safir-villain__heading, .safir-villain__intro', fx: 'up' },
    {
      sel: '.safir-hiw__heading, .safir-buy__heading, .safir-ing__heading, .safir-compare__heading, .safir-ugc__heading, .safir-creators__heading, .safir-founder__heading',
      fx: 'heading'
    }
  ];
  const STAGGER_CAP = 5;

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sr-in');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  const tag = () => {
    for (const group of GROUPS) {
      const els = document.querySelectorAll(group.sel);
      const byParent = new Map();
      els.forEach((el) => {
        if (el.hasAttribute('data-sr')) return;
        const i = byParent.get(el.parentElement) || 0;
        byParent.set(el.parentElement, i + 1);
        el.setAttribute('data-sr', group.fx);
        el.style.setProperty('--sr-i', Math.min(i, STAGGER_CAP));
        io.observe(el);
      });
    }
  };

  const start = () => {
    document.documentElement.classList.add('safir-motion');
    tag();
    /* Safety net: anything still hidden after 2.5s becomes visible. */
    setTimeout(() => {
      document.querySelectorAll('[data-sr]:not(.sr-in)').forEach((el) => el.classList.add('sr-in'));
    }, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /* Re-tag when the theme editor reloads a section. */
  document.addEventListener('shopify:section:load', tag);
})();
